import script from "./ImageCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageCarousel.vue?vue&type=script&setup=true&lang=js"

import "./ImageCarousel.vue?vue&type=style&index=0&id=b4bcaf30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4bcaf30"]])

export default __exports__